module.exports = __webpack_public_path__ + "static/47-61345e4903db1d9a81c2b60b11e58c1a.png";